import React from "react";
import { useLocation } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Header from "../../Componentes/Generales/Header/Header.jsx";
import HeaderLinks from "../../Componentes/Generales/Header/HeaderLinks.jsx";
import footerStyle from "assets/jss/material-kit-pro-react/components/footerStyle.jsx";
import Seccion8 from "../../Componentes/PaginaPrincipal/Seccion/seccion8";
// Modal de bienvenida deshabilitado (ver ModalBienvenida.jsx)
// import ModalBienvenida, { BIENVENIDA_STORAGE_KEY } from "../../Componentes/Generales/Modales/ModalBienvenida.jsx";

/**
 * Layout component that wraps all routes and adds a global Footer
 * Excludes Footer from specific routes (login, verification, etc.)
 * Header siempre se muestra excepto en rutas específicas
 */
function Layout({ children }) {
	const location = useLocation();
	const pathname = decodeURIComponent(location.pathname);

	// Rutas que NO deben mostrar el Footer global
	const excludedRoutes = [
		"/login",
		"/ValidarAcceso",
		"/login-page",
		"/error-page", // ErrorPage ya tiene su propio Footer
		"/diseñador3D",
	];

	// Rutas que NO deben mostrar el Header
	const excludedHeaderRoutes = [];

	const shouldShowFooter = !excludedRoutes.includes(pathname);
	const shouldShowHeader = !excludedHeaderRoutes.includes(pathname);

	return (
		<>
			{shouldShowHeader && (
				<Header
					links={<HeaderLinks dropdownHoverColor="dark" />}
					fixed
					color="dark"
				/>
			)}
			{children}
			{shouldShowFooter && <Seccion8 />}
		</>
	);
}

export default withStyles(footerStyle)(Layout);
